module.exports = __webpack_public_path__ + "static/media/block-balances.167aab62.svg";